import React, { useEffect } from 'react';

const Product5 = () => {
  useEffect(() => {
    // Scroll to the top of the page when the component is mounted
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="p-10 bg-black text-white">
      {/* Company Name at the Top */}
      <h1 className="text-4xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-white to-black animate-slide-in">
        Fujian Wellson Machinery
      </h1>

      <h1 className="text-4xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-white to-black animate-slide-in leading-snug">
        Fujian Wellson Machinery Co., Ltd.
      </h1>

      <div className="space-y-12">

        {/* Company Overview Section */}
        <section className="flex flex-col lg:flex-row items-center lg:space-x-8">
          <div className="lg:w-1/2 mb-6 lg:mb-0">
            <img
              src="https://cdn.globalso.com/wellsonmachinery/ab42f7cd.jpg"
              alt="Company Overview"
              className="rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2">
            <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
              Company Overview
            </h3>
            <p className="text-lg leading-relaxed transition duration-500 ease-in-out transform hover:scale-105 hover:text-gray-200">
              Fujian Wellson Machinery specializes in the development and manufacturing of cast film lines, MDO film lines, and extrusion coating lines. Our innovative technology and extensive experience contribute to the building of high-performance casting film machinery for a wide range of industries, including flexible packaging, hygiene, medical, construction, and agriculture.
            </p>
          </div>
        </section>

        {/* Cast Embossed Film Line Section */}
        <section className="flex flex-col lg:flex-row-reverse items-center lg:space-x-8">
          <div className="lg:w-1/2 mb-6 lg:mb-0">
            <img
              src="https://cdn.globalso.com/wellsonmachinery/3b2a9231.jpg"
              alt="Cast Embossed Film Line"
              className="rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2">
            <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
              Cast Embossed Film Line
            </h3>
            <p className="text-lg leading-relaxed transition duration-500 ease-in-out transform hover:scale-105 hover:text-gray-200">
              Our Cast Embossed Film Line produces melt-embossed PE film with a wide range of applications, including PE film for baby diapers, sanitary napkins, medical dressings, gloves, shower curtains, and more.
            </p>
          </div>
        </section>

        {/* High Transparent Multi-layer CPE Cast Film Line Section */}
        <section className="flex flex-col lg:flex-row items-center lg:space-x-8">
          <div className="lg:w-1/2 mb-6 lg:mb-0">
            <img
              src="https://cdn.globalso.com/wellsonmachinery/7f5e6b9b.jpg"
              alt="High Transparent Multi-layer CPE Cast Film Line"
              className="rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2">
            <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
              High Transparent Multi-layer CPE Cast Film Line
            </h3>
            <p className="text-lg leading-relaxed transition duration-500 ease-in-out transform hover:scale-105 hover:text-gray-200">
              The CPE cast film line produces high-quality transparent polyethylene films (CPE) with superior properties such as better transparency, thickness variation, and other technical features. These films are widely used in food packaging, consumer goods, and surface protection.
            </p>
          </div>
        </section>

        {/* Multi-layer Co-Extrusion CPP Cast Film Line Section */}
        <section className="flex flex-col lg:flex-row-reverse items-center lg:space-x-8">
          <div className="lg:w-1/2 mb-6 lg:mb-0">
            <img
              src="https://cdn.globalso.com/wellsonmachinery/230.jpg"
              alt="Multi-layer Co-Extrusion CPP Cast Film Line"
              className="rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2">
            <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
              Multi-layer Co-Extrusion CPP Cast Film Line
            </h3>
            <p className="text-lg leading-relaxed transition duration-500 ease-in-out transform hover:scale-105 hover:text-gray-200">
              Our CPP Cast Film Line produces high-quality cast polypropylene films for packaging applications. This line creates films with high transparency and minimal gauge variation, making them ideal for lamination and metalizing processes.
            </p>
          </div>
        </section>

        {/* EVA / PEVA Cast Film Extrusion Line Section */}
        <section className="flex flex-col lg:flex-row items-center lg:space-x-8">
          <div className="lg:w-1/2 mb-6 lg:mb-0">
            <img
              src="https://cdn.globalso.com/wellsonmachinery/EVA-POE-Solar-Panel-Encapsulation-Film-Line.png"
              alt="EVA / PEVA Cast Film Extrusion Line"
              className="rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2">
            <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
              EVA / PEVA Cast Film Extrusion Line
            </h3>
            <p className="text-lg leading-relaxed transition duration-500 ease-in-out transform hover:scale-105 hover:text-gray-200">
              This line uses EVA resin to produce EVA films, and can also combine different resin materials such as EVA, LDPE, LLDPE, and HDPE. Our cast film machines for EVA/PEVA films are specifically designed for these thermoplastic polymers.
            </p>
          </div>
        </section>

        {/* Contact Us Section */}
        <section className="mt-12 text-center">
          <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
            Contact Us
          </h3>
          <p className="text-lg">
            For more information about our products and services, please contact us at:- 
            <a href="mailto:rambomble@alphaq.co.in" className="text-blue-500 hover:text-blue-700 transition-colors duration-300">
            rambomble@alphaq.co.in
            </a>
          </p>
        </section>

      </div>
    </div>
  );
};

export default Product5;
